// extracted by mini-css-extract-plugin
module.exports = {"two_column_form":"_2fJ0lrN _1pO3EYC","row":"_3RkO-6x _2wW_gNj","header_col":"_3l6djDy _1npT0qO _3fjjk5n","header_btn_col":"_2E1LQfp _1npT0qO _2SUECq4"};